import { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import NavigationBar from './components/NavigationBar';
import WhyChooseSection from './components/WhyChooseSection';
import MobileWhyChooseSection from './components/MobileWhyChooseSection';
import ResultsSection from './components/ResultsSection';
import StudentCarousel from './components/StudentCarousel';
import TestimonialsSection from './components/TestimonialsSection';
import HolisticDevelopmentSection from './components/HolisticDevelopmentSection';
import TeachersSection from './components/TeachersSection';
import CallToActionSection from './components/CallToActionSection';
import NewFooter from './components/NewFooter';
import CompetitiveExams from './components/CompetitiveExams';
import FloatingPhone from './components/FloatingPhone';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import AboutUs from './components/AboutUs';
import PosterCarousel from './components/PosterCarousel';
import CourseSection from './components/CourseSection';
import ScrollToTop from './components/ScrollToTop';
import ContactUs from './components/ContactUs';
import Examin8Section from './components/Examin8Section';
import VisitorCounter from './components/VisitorCounter';
import PhotoGallery from './components/PhotoGallery';
import emailjs from '@emailjs/browser';
import { Helmet } from 'react-helmet';
import { Breadcrumb } from './components/Breadcrumb';
import Maintenance from './components/Maintenance';
import { DataDeletion, PrivacyPolicy } from './components/LegalPages';

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  return (
    <>
      <Helmet>
        <title>ADCI - Defense Career Guidance | Choose Your Learning Path</title>
        <meta name="description" content="Start your defense career journey with personalized guidance. Flexible learning options - join our campus classes or study online. Expert mentors, proven study methods, and a supportive learning environment." />
        <meta name="keywords" content="defense career, military training, NDA coaching, CDS preparation, SSB guidance, online classes, classroom training" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://www.adcionline.com"
            }]
          })}
        </script>
      </Helmet>
      <Breadcrumb />
      {isLoading ? (
        <div className="loading-spinner">Loading...</div>
      ) : (
        <>
          <PosterCarousel />
          {/* ...existing code... */}
          <Examin8Section />
          <VisitorCounter />
          <WhyChooseSection />
          <MobileWhyChooseSection />
          <ResultsSection />
          <StudentCarousel />
          <TestimonialsSection />
          <CourseSection />
          <HolisticDevelopmentSection />
          <TeachersSection />
          <CallToActionSection />
        </>
      )}
    </>
  );
};

const CompetitiveExamsWithSEO = () => (
  <>
    <Helmet>
      <title>Defense Competitive Exams Preparation | ADCI</title>
      <meta name="description" content="Comprehensive preparation for NDA, CDS, AFCAT, and other defense exams. Expert guidance for written tests and SSB interviews." />
      <meta name="keywords" content="NDA preparation, CDS coaching, AFCAT training, SSB interview, defense exams" />
    </Helmet>
    <CompetitiveExams />
  </>
);

const AboutWithSEO = () => (
  <>
    <Helmet>
      <title>About ADCI - Legacy in Defense Training</title>
      <meta name="description" content="35+ years of excellence in defense training. Learn about our unique SATTAS methodology and success stories." />
      <meta name="keywords" content="defense institute, SATTAS methodology, military training institute" />
    </Helmet>
    <AboutUs />
  </>
);

const ContactWithSEO = () => (
  <>
    <Helmet>
      <title>Contact ADCI - Start Your Defense Journey</title>
      <meta name="description" content="Get in touch with our experts. Choose between online and offline coaching programs. Begin your path to a defense career." />
      <meta name="keywords" content="defense coaching admission, military exam guidance, career counseling" />
    </Helmet>
    <ContactUs />
  </>
);

const PhotoGalleryWithSEO = () => (
  <>
    <Helmet>
      <title>Photo Gallery - ADCI</title>
      <meta name="description" content="Explore our photo gallery showcasing campus life, training sessions, and success stories at ADCI." />
      <meta name="keywords" content="ADCI gallery, defense training photos, campus life, student activities" />
    </Helmet>
    <PhotoGallery />
  </>
);

function App() {
  useEffect(() => {
    emailjs.init("kvXeBxhzAY0NseXKU"); 
  }, []);

  const ScrollWrapper = ({ children }) => {
    useEffect(() => {
      const navbarToggle = document.querySelector('.navbar-toggler');
      const navbarCollapse = document.querySelector('.navbar-collapse');
      if (navbarCollapse && navbarCollapse.classList.contains('show')) {
        navbarToggle.click();
      }

      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      const timeoutId = setTimeout(() => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }, 100);

      return () => clearTimeout(timeoutId);
    }, []);
    return children;
  };

  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <NavigationBar />
        <Routes>
          <Route path="/" element={<ScrollWrapper><Home /></ScrollWrapper>} />
          <Route path="/about" element={<ScrollWrapper><AboutWithSEO /></ScrollWrapper>} />
          <Route path="/updates" element={<ScrollWrapper><Maintenance /></ScrollWrapper>} />
          <Route path="/competitive-exams" element={<ScrollWrapper><CompetitiveExamsWithSEO /></ScrollWrapper>} />
          <Route path="/contact" element={<ScrollWrapper><ContactWithSEO /></ScrollWrapper>} />
          <Route path="/gallery" element={<ScrollWrapper><PhotoGalleryWithSEO /></ScrollWrapper>} />
          <Route path="/privacy-policy" element={<ScrollWrapper><PrivacyPolicy /></ScrollWrapper>} />
          <Route path="/data-deletion" element={<ScrollWrapper><DataDeletion /></ScrollWrapper>} />
        </Routes>
        <NewFooter />
        <FloatingPhone />
        <FloatingWhatsApp />
      </div>
    </Router>
  );
}

export default App;
